import { Countertop } from '../countertop.class';
import { RenderDetails, Vertex2 } from '../../../spatial-classes';

export const getRenderingDetailsCfn = (countertop: Countertop): RenderDetails => {
	const island = countertop.refMap.kitchen?.design.islands.findById(countertop.islandIds[0]);

	const vertices = island.panels.children.map((panel) => {
		const panelPoints = panel.getSidePoints({ includeCountertop: true, translate: true, rotate: true }).corners;
		return new Vertex2({ dataIn: { x: panelPoints[0].x, y: panelPoints[0].z }});
	});

	const v = {
		vertices,
		depth: countertop.material.thickness,
		layer: countertop.instanceOf
	};

	// console.log('countertop:getRenderDetailsCfn', v);
	return v;
};
